document.addEventListener('DOMContentLoaded', function(){
  var anav = document.getElementById('MrAnav');
  var links = document.querySelectorAll('#MrAnavLinks a');
  var cta = document.getElementById('MrAnavCta');
  if (!anav || !cta) return;

  var realForm = document.querySelector('product-form');
  var realBtn = document.querySelector('button.m-add-to-cart[type="submit"][name="add"]');
  var bundleCta = document.getElementById('MrBundleCta');
  var variantInput = realForm ? realForm.querySelector('input[name="id"]') : document.querySelector('input[name="id"][data-selected-variant]');

  function resolveTarget(id){
    var el = document.getElementById(id);
    if(!el && id === 'reviews'){
      el = document.querySelector('.jdgm-rev-widg');
    }
    return el;
  }

  // ---- Show/hide nav based on real buy box position ----
  function checkVisibility(){
    if(!realForm){
      if(window.scrollY > 500){ anav.classList.add('is-visible'); } else { anav.classList.remove('is-visible'); }
      return;
    }
    var rect = realForm.getBoundingClientRect();
    if(rect.bottom < 0){ anav.classList.add('is-visible'); } else { anav.classList.remove('is-visible'); }
  }
  checkVisibility();

  // ---- Build section list using the same fallback resolver ----
  var sections = [];
  function rebuildSections(){
    sections = [];
    links.forEach(function(link){
      var id = link.getAttribute('data-target');
      var el = resolveTarget(id);
      link.hidden = !el;
      if(el) sections.push({id:id, el:el, link:link});
    });
  }
  rebuildSections();
  var rebuildQueued = false;
  var pageContent = document.getElementById('MainContent');
  if(pageContent) new MutationObserver(function(){
    if(rebuildQueued) return;
    rebuildQueued = true;
    requestAnimationFrame(function(){ rebuildQueued=false; rebuildSections(); updateActive(); });
  }).observe(pageContent,{childList:true,subtree:true});

  var suppressScrollHighlight = false;

  function updateActive(){
    if(suppressScrollHighlight) return;
    var scrollPos = window.scrollY + 120;
    var current = null;
    sections.forEach(function(s){ if(s.el.getBoundingClientRect().top + window.scrollY <= scrollPos){ current = s; } });
    links.forEach(function(l){ l.classList.remove('is-active'); });
    if(current){ current.link.classList.add('is-active'); }
  }
  var scrollQueued = false;
  window.addEventListener('scroll', function(){
    if(scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(function(){ scrollQueued=false; checkVisibility(); updateActive(); });
  }, {passive:true});
  updateActive();

  // ---- Nav link click: instant underline + smooth scroll ----
  links.forEach(function(link){
    link.addEventListener('click', function(e){
      e.preventDefault();
      var id = link.getAttribute('data-target');
      var el = resolveTarget(id);

      links.forEach(function(l){ l.classList.remove('is-active'); });
      link.classList.add('is-active');
      suppressScrollHighlight = true;

      if(el){
        var top = el.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({top: top, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }

      clearTimeout(window._mrAnavScrollLock);
      window._mrAnavScrollLock = setTimeout(function(){ suppressScrollHighlight = false; }, 900);
    });
  });

  // ---- Live price sync, read from variant JSON (not scraped text) ----
  var variantsData = null;
  try {
    var vjson = document.getElementById('MrAnavVariants');
    if(vjson){ variantsData = JSON.parse(vjson.textContent); }
  } catch(e){ variantsData = null; }

  function money(cents){
    if(typeof cents !== 'number') return '';
    return 'Rs.' + (cents/100).toLocaleString('en-PK', {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  function updateCtaPrice(vidOverride){
    if(!variantsData){ cta.textContent = 'Add to Cart'; return; }
    var vid = vidOverride;
    if(vid == null && variantInput){ vid = parseInt(variantInput.value, 10); }
    var v = variantsData.filter(function(item){ return item.id === vid; })[0];
    cta.textContent = v ? ('Add to Cart | ' + money(v.price)) : 'Add to Cart';
  }
  updateCtaPrice();

  if(variantInput){
    var mo = new MutationObserver(function(){ updateCtaPrice(); });
    mo.observe(variantInput, {attributes:true, attributeFilter:['value','data-selected-variant']});
    variantInput.addEventListener('change', function(){ updateCtaPrice(); });
  }
  document.addEventListener('change', function(e){
    if(e.target && e.target.closest && e.target.closest('product-form')){
      setTimeout(function(){ updateCtaPrice(); }, 150);
    }
  });

  // ---- CTA click triggers the bundle selector's own Add to Cart logic (correct variant lookup) ----
  cta.addEventListener('click', function(e){
    e.preventDefault();
    if(bundleCta){ bundleCta.click(); }
    else if(realBtn){ realBtn.click(); }
  });

  // ---- Size dropdown: bridges to the MrBundle selector ----
  var sizeWrap = document.getElementById('MrAnavSize');
  var sizeToggle = document.getElementById('MrAnavSizeToggle');
  var sizeLabel = document.getElementById('MrAnavSizeLabel');
  var sizeMenu = document.getElementById('MrAnavSizeMenu');

  if(sizeWrap && sizeToggle && sizeLabel && sizeMenu){

    function closeMenu(){
      sizeMenu.classList.remove('is-open');
      sizeToggle.setAttribute('aria-expanded', 'false');
    }
    function toggleMenu(){
      var open = sizeMenu.classList.toggle('is-open');
      sizeToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    sizeToggle.addEventListener('click', function(e){
      e.stopPropagation();
      toggleMenu();
    });
    document.addEventListener('click', function(e){
      if(!sizeWrap.contains(e.target)){ closeMenu(); }
    });

    function buildMenu(){
      if(!window.MrBundle) return false;
      var sizes = window.MrBundle.getSizes();
      if(!sizes || !sizes.length) return false;
      sizeMenu.innerHTML = '';
      sizes.forEach(function(sizeVal){
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'mr-anav__size-item';
        item.setAttribute('data-size', sizeVal);
        item.textContent = sizeVal;
        item.addEventListener('click', function(){
          window.MrBundle.setSize(sizeVal);
          closeMenu();
        });
        sizeMenu.appendChild(item);
      });
      return true;
    }

    function reflectState(state){
      if(!state) return;
      sizeLabel.textContent = state.size || '';
      Array.prototype.forEach.call(sizeMenu.querySelectorAll('.mr-anav__size-item'), function(item){
        item.classList.toggle('is-active', item.getAttribute('data-size') === state.size);
      });
      if(state.variant){ updateCtaPrice(state.variant.id); }
    }

    // Wait for MrBundle to be ready (its script may still be initializing)
    var attempts = 0;
    var readyPoll = setInterval(function(){
      attempts++;
      if(window.MrBundle && buildMenu()){
        clearInterval(readyPoll);
        sizeWrap.style.display = 'flex';
        reflectState(window.MrBundle.getState());
      } else if(attempts > 40){ // ~4s of polling, then give up quietly
        clearInterval(readyPoll);
      }
    }, 100);

    document.addEventListener('mr:bundle:change', function(e){
      reflectState(e.detail);
    });
  }
});
